import React, {useState, useEffect} from 'react';

import MathJax from "../../../components/react-mathjax-preview";
import MQTSelectBox from './MQTSelectBox';


const MQTDisplayOption1 = props => {
    const [questions, setQuestions] = useState([]);

    useEffect(()=>{
        if(props.mqt_questions){
            setQuestions(shuffle(Object.values(props.mqt_questions), props.random_order))
        }
    },[props.mqt_questions])

    const shuffle=(arra1, random_order) =>{
        if(arra1 && random_order) {
          var ctr = arra1.length, temp, index;
          // While there are elements in the array
              while (ctr > 0) {
          // Pick a random index
                  index = Math.floor(Math.random() * ctr);
          // Decrease ctr by 1
                  ctr--;
          // And swap the last element with it
                  temp = arra1[ctr];
                  arra1[ctr] = arra1[index];
                  arra1[index] = temp;
              }
        } else {
            arra1 = arra1.sort((a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder));
        }
        return arra1;
    }

    return <div className='sf-mqt-table'>
        <table>
            <tbody>
                {
                    questions.map(question=>{
                        let content   =   React.createElement(MathJax,{"math":question.value});
                        let radioButtons = [];
                        const question_answer_map = props.question_answer_map;
                        for (let index = 1; index <= props.mqt_answer_count; index++) {
                            let answers  =  question_answer_map[question.id];
                            let checked = false;
                            if(answers && answers.includes(index.toString()))
                                checked = true;
                            radioButtons.push(<td> <MQTSelectBox checked={checked} type={props.type} questionID={props.questionID} onClick={ (checked) =>{props.onAnswerChoice(checked,{qID:question.id,aID:index.toString()})}} value={index}/></td>);                           
                        }
                        return <tr>
                                    <td>{content}</td>
                                    {radioButtons}
                                </tr>
                    })
                }
            </tbody>
        </table>    
    </div>
}

export default MQTDisplayOption1;